import { useMsal } from "@azure/msal-react";
import { useState } from "react";

import { loginRequest } from "@/lib/auth";

export function LoginPage() {
  const { instance } = useMsal();
  const [busy, setBusy] = useState(false);

  const login = async () => {
    setBusy(true);
    try {
      await instance.loginPopup(loginRequest);
    } catch {
      // el usuario cerró el popup o falló; no hacemos nada
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="bg-white border rounded-xl shadow-sm p-8 max-w-sm w-full text-center">
        <div className="flex justify-center mb-4">
          <img src="/logo-mark.png" alt="MPP Energía" className="w-16 h-16" />
        </div>
        <h1 className="text-xl font-semibold text-slate-900">Organización MPP</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">
          Programa de vacaciones del equipo. Inicia sesión con tu cuenta de MPP Energía.
        </p>
        <button
          type="button"
          onClick={login}
          disabled={busy}
          className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 text-white font-medium rounded-md px-4 py-2.5 hover:bg-slate-800 disabled:opacity-50"
        >
          <MicrosoftIcon />
          {busy ? "Conectando…" : "Iniciar sesión con Microsoft"}
        </button>
        <p className="text-[11px] text-slate-400 mt-4">
          Solo cuentas <span className="font-medium">@mppenergia.com</span> y{" "}
          <span className="font-medium">@panterainfra.com</span>.
        </p>
      </div>
    </div>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden="true">
      <rect x="1" y="1" width="10" height="10" fill="#F35325" />
      <rect x="12" y="1" width="10" height="10" fill="#81BC06" />
      <rect x="1" y="12" width="10" height="10" fill="#05A6F0" />
      <rect x="12" y="12" width="10" height="10" fill="#FFBA08" />
    </svg>
  );
}
